import script from "./DetailsLOCV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailsLOCV2.vue?vue&type=script&setup=true&lang=ts"

import "./DetailsLOCV2.vue?vue&type=style&index=0&id=02e4d787&scoped=true&lang=css"
import "@/assets/css/application-details/student.css?vue&type=style&index=1&id=02e4d787&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02e4d787"]])

export default __exports__